module.exports = __webpack_public_path__ + "static/media/entralpi_logo.eff16368.png";